import { render, staticRenderFns } from "./ContentActions.vue?vue&type=template&id=6681dba6"
import script from "./ContentActions.vue?vue&type=script&lang=js"
export * from "./ContentActions.vue?vue&type=script&lang=js"
import style0 from "./ContentActions.vue?vue&type=style&index=0&id=6681dba6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports